module.exports = require('./lib/static/prefixAll')



//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/inline-style-prefixer/static.js
// module id = 769
// module chunks = 5